import { MaterialIcon } from "@eusoft/webapp-ui";
import { Popup } from "@eusoft/webapp-ui/components/Popup";
import { formatCurrency, formatText } from "@eusoft/webapp-ui/utils/Format";
import type { LocalString } from "@eusoft/webapp-ui/types";
import "./WaitForCard.scss";


interface IWaitForCardOptions {
    message: LocalString;
    amount?: number;
}

export function showWaitForCardAsync<T>(options: IWaitForCardOptions, action: () => Promise<T>) {

    const popup = new Popup();
    popup.style = "wait-for-card";
    popup.title = formatText("wait-for-card");
    popup.body = <>

        <div className="icon-container">
            <div className="icon-wrapper" />
            <MaterialIcon name="nfc"/>
        </div>
        {options.message && <div className="message">{formatText(options.message)}</div>}
        {options.amount && <div className="amount">{formatCurrency(options.amount)}</div>}
    </>;

    popup.actions = [{
        name: "cancel",
        text: "cancel",
        executeAsync: async () => true
    }];


    return new Promise<T>(async (res, rej) => {

        let isResolved = false;

        popup.showAsync().then(() => {

            if (!isResolved) 
                res(undefined);

            isResolved = true;
        });

        try {
            const result = await action();
            if (!isResolved)
                res(result);        
        }
        catch (ex) {

            console.warn("showWaitForCardAsync", ex);

            if (!isResolved)
                rej(ex);
        }

        isResolved = true;
        popup.close();        
    });

}